namespace Entities {

    export class Current
        implements RavenDocument {
        
        id: string = Current.getId();        
        order?: Order;

        static getId() {
            return "_local/Current";
        }

        static cast(obj: any, prototype: any) {
            Object.setPrototypeOf(obj, prototype); 
            Order.cast(obj.order, Order.prototype);
        }
    }
}